<template>
  <div class="common-title">
    <div class="common-title-wrap">
      <h1>@ {{ title }}</h1>

      <pb-tag :color="status_to_color">{{ status }}</pb-tag>
      <div class="common-title-date">
        <span>{{ start }}</span>
        <span>-</span>
        <span>{{ end }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CommonTitle",
  props: {
    clearBoth: Boolean,
    full: Boolean,
    title: String,
    status: String,
    start: String,
    end: String,
    backbutton: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    status_to_color() {
      switch (this.status) {
        case "진행중":
          return "success";
        case "예약":
          return "disabled";
        case "종료":
          return "error";
        default:
          return "disabled";
      }
    },
  },
};
</script>
<style lang="scss">
@import "~styles/size";

.common-title {
  padding-top: 0.8rem;
  padding-bottom: 1.2rem;

  .common-title-date {
    font-size: 14px;
    font-weight: 500;
  }

  .common-title-wrap {
    display: flex;
    align-items: center;

    @media (max-width: $min_layout) {
      flex-direction: column;
    }

    * + * {
      margin-left: 1.4rem;
      @media (max-width: $min_layout) {
        margin-top: 10px;
      }
    }
  }

  h1 {
    font-size: 24px;
  }
}
</style>
